import { GenericLink } from "../../link";
import { unstable_Typography } from "../../typography";
function copyRichTextData(value, context) {
  if (value == null)
    return value;
  return {
    ...value,
    document: value.document ? copyNode(value.document) : value.document
  };
  function copyNode(node) {
    switch (node.object) {
      case "document":
      case "block":
      case "inline":
        return copyInline(node);
      case "text":
        return { ...node, marks: node.marks?.map(copyMark) };
      default:
        return node;
    }
  }
  function copyInline(inline) {
    switch (inline.type) {
      case "link":
        return {
          ...inline,
          nodes: inline.nodes?.map(copyNode),
          data: GenericLink().copyData(inline.data, context)
        };
      default:
        return { ...inline, nodes: inline.nodes?.map(copyNode) };
    }
  }
  function copyMark(mark) {
    switch (mark.type) {
      case "typography": {
        return {
          ...mark,
          data: {
            ...mark.data,
            value: unstable_Typography().copyData(mark.data?.value, context)
          }
        };
      }
      default:
        return mark;
    }
  }
}
export {
  copyRichTextData
};
//# sourceMappingURL=copy.js.map